export default __webpack_public_path__ + "static/media/announcement.29bcdd2d.svg";